module.exports = __webpack_public_path__ + "static/img/安全通道icon.00c3684c.svg";